import { useEffect } from "react";
import useLocalStorage from "@catchy/app-core/src/useLocalStorage";
import { favouriteDetailsKey, mergeFavouriteStopDetails, updateFavouriteStopDetails } from "@catchy/app-core/src/favouriteStopDetails";
import Star from "@catchy/assets/svgs/star.svg";
import IconButton from "./IconButton";
export default function FavouriteButton({
  stopId,
  stop,
  useStorage = useLocalStorage,
  favourites,
  setFavourites,
  variant = "icon"
}) {
  const isFavourited = Array.isArray(favourites) && favourites.includes(stopId);
  const [details, setDetails] = useStorage(favouriteDetailsKey, {});
  useEffect(() => {
    const rows = stop ? [{
      ...stop,
      stop_id: stopId
    }] : [];
    if (!isFavourited || !stop || details && Object.hasOwn(details, stopId) || mergeFavouriteStopDetails(details, rows, favourites) === details) return;
    // Seed only: an ISR stop page can be older than the background ID check.
    // Never replace refreshed defaults with an older page snapshot.
    void setDetails(current => current && Object.hasOwn(current, stopId) ? current : mergeFavouriteStopDetails(current, rows, favourites));
  }, [details, isFavourited, setDetails, stop, stopId, favourites]);
  const toggleFavourite = value => {
    // Write default details in the same interaction, without waiting for a
    // page effect or the background name check. Custom names are independent.
    void setDetails(current_0 => updateFavouriteStopDetails(current_0, value, stop, !isFavourited));
    void setFavourites((current_1 = []) => {
      const list = Array.isArray(current_1) ? current_1 : [];
      return list.includes(value) ? list.filter(item => item !== value) : [...list, value];
    });
  };
  if (variant === "pill") {
    return <button type="button" aria-pressed={isFavourited} onClick={() => toggleFavourite(stopId)} className={`inline-flex flex-1 flex-shrink-0 items-center justify-center gap-1 rounded-full py-2 pl-2.5 pr-4 text-center text-sm font-semibold leading-tight outline-none ring-1 transition-colors motion-reduce:transition-none focus-visible:ring ${isFavourited ? "bg-orange-50 text-orange-600 ring-orange-300/80 hover:bg-orange-100 focus-visible:ring-orange-300/80 dark:bg-orange-500/10 dark:text-orange-300 dark:ring-orange-300/40 dark:hover:bg-orange-500/20" : "bg-white text-blue-500 ring-blue-500/50 hover:bg-zinc-100 focus-visible:ring-blue-500/50 dark:bg-black dark:text-blue-300 dark:ring-blue-300 dark:hover:bg-zinc-800"}`} title={isFavourited ? "Remove from favourites." : "Add to favourites"}>
        <Star className={`h-4 w-4 transition-colors duration-300 motion-reduce:transition-none ${isFavourited ? "text-orange-400" : "text-zinc-400/60"}`} />
        {isFavourited ? "Favourited" : "Favourite"}
      </button>;
  }
  return <IconButton label={isFavourited ? "Remove from favourites" : "Add to favourites"} aria-pressed={isFavourited} onClick={() => toggleFavourite(stopId)}>
      <Star className={`${isFavourited ? "text-orange-400" : "text-zinc-400/60"} h-6 w-6 transition-colors duration-300 motion-reduce:transition-none`} aria-hidden="true" />
    </IconButton>;
}